function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29.0861 1.19568C29.4298 2.13522 28.9468 3.17552 28.0073 3.51925L20.0995 6.41234L28.6547 9.79463C29.5851 10.1624 30.0411 11.2148 29.6733 12.1452C29.3055 13.0756 28.2531 13.5316 27.3227 13.1638L15.0065 8.29463L2.69035 13.1638C1.75998 13.5316 0.707583 13.0756 0.33976 12.1452C-0.0280624 11.2148 0.427976 10.1624 1.35835 9.79463L10.0208 6.36996L2.58172 3.50879C1.64796 3.14965 1.18213 2.10155 1.54127 1.16778C1.90041 0.234023 2.94851 -0.2318 3.88228 0.127338L15.0224 4.41202L26.7625 0.116873C27.702 -0.226861 28.7423 0.256135 29.0861 1.19568Z"
});

function SvgCrossmarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossmarker);
export default __webpack_public_path__ + "static/media/crossmarker.09ecf77a.svg";
export { ForwardRef as ReactComponent };